import UserModel from "./user-model";

export default UserModel;